import { buttonClasses, capitalize, Paper, styled } from "@mui/material";
import { actionBarName } from "../classes.js";
const List = styled(Paper, {
  name: actionBarName,
  overridesResolver: (props, styles) => {
    const { ownerState } = props;
    return [styles.list, ownerState?.menuMode && styles[`list${capitalize(ownerState.menuMode)}`]];
  },
  slot: "List"
})(({ theme, ownerState }) => {
  const spans = `> span`;
  const descendantButtonRoots = `${spans} > .${buttonClasses.root}`;
  const firstDescendantButtonRoot = `${spans}:first-of-type >.${buttonClasses.root}`;
  const lastDescendantButtonRoot = `${spans}:last-child > .${buttonClasses.root}`;
  return {
    display: "flex",
    flexDirection: "column",
    zIndex: (theme.vars ?? theme).zIndex.modal + 1,
    ...ownerState?.menuMode === "iconOnly" && {
      flexDirection: "row"
    },
    // square-off buttons in the list
    [descendantButtonRoots]: {
      borderRadius: "0px",
      justifyContent: "flex-start"
    },
    [firstDescendantButtonRoot]: {
      borderTopLeftRadius: (theme.vars ?? theme).shape.borderRadius,
      borderTopRightRadius: (theme.vars ?? theme).shape.borderRadius
    },
    [lastDescendantButtonRoot]: {
      borderBottomLeftRadius: (theme.vars ?? theme).shape.borderRadius,
      borderBottomRightRadius: (theme.vars ?? theme).shape.borderRadius
    }
  };
});
export {
  List
};
//# sourceMappingURL=List.js.map
